import { makeAutoObservable } from 'mobx'

import {
  KyrgyzstanSearchApi,
  type RealtyType,
} from 'shared/api/kyrgyzstan/search'
import { RealtyTypesRequest } from 'shared/api/kyrgyzstan/search/model'
import { getApiErrorMessage } from 'shared/lib/errorText'
import { simpleIsEqual } from 'shared/lib/simpleIsEqual'

class KyrgyzstanRealtyTypesStore {
  realtyTypes: RealtyType[] = []
  isLoading = false
  error: string | null = null
  prevParams?: RealtyTypesRequest

  constructor() {
    makeAutoObservable(this)
  }

  setLoading = (loading: boolean) => {
    this.isLoading = loading
  }

  setError = (error: string | null) => {
    this.error = error
  }

  setRealtyTypes = (types: RealtyType[]) => {
    this.realtyTypes = types
  }

  fetchRealtyTypes = async (params?: RealtyTypesRequest) => {
    if (this.realtyTypes.length > 0 && simpleIsEqual(this.prevParams, params)) {
      return
    }

    this.prevParams = params

    this.setLoading(true)
    this.setError(null)

    try {
      const { data } = await KyrgyzstanSearchApi.getRealtyTypes(params)
      this.setRealtyTypes(data.data)
    } catch (error) {
      const errorMessage = getApiErrorMessage(error)
      this.setError(errorMessage)
    } finally {
      this.setLoading(false)
    }
  }

  reset = () => {
    this.realtyTypes = []
    this.isLoading = false
    this.error = null
  }
}

export const kyrgyzstanRealtyTypesStore = new KyrgyzstanRealtyTypesStore()
